import React from 'react';
import { CancelConfirmModal } from '../..';



const  BasicFormElementModal = ({headerText, questionText, onCloseClick, onConfirmClick}:{headerText: string, questionText: any, onCloseClick: ()=>void, onConfirmClick: ()=> void}) => {
    return (
        <CancelConfirmModal
            className={"form-builder-modal"}
            isAlertStyle={true}
            headerContent={<div className='form-builder-modal-header'>{headerText}</div>}
            bodyContent={<div className='form-builder-modal-question'>{questionText}</div>}
            onCloseClick={onCloseClick}
            cancelButtonText={"Cancel"}
            cancelButtonAriaLabel={"Cancel and close modal"}
            confirmButtonText={"Confirm"}
            confirmButtonAriaLabel={"Confirm and close modal"}
            onCancelClick={onCloseClick}
            onConfirmClick={onConfirmClick}
        />
    );
};

export default BasicFormElementModal;